<crud-list class="col-12" [data]="table" detailUrl="/enaio-learn/admin/inspection-phase/" restUrl="api/lrn/inspectionphase">
</crud-list>
